import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'

import { deactivateZendeskIntegration, updateTicketTagsAndComment } from 'actions'

import TagsAndCommentSettingsPresentation from 'components/Admin/Surveys/ZendeskIntegrationSettings/TagsAndCommentSettings'

class TagsAndCommentSettings extends React.Component {
  static propTypes = {
    tags: PropTypes.object.isRequired,
    comment: PropTypes.string.isRequired,
    updateTicketTagsAndComment: PropTypes.func.isRequired,
    deactivateZendeskIntegration: PropTypes.func.isRequired,
    hideRemoveIntegration: PropTypes.bool,
  }

  static defaultProps = {
    tags: {
      good: 'ss_good_satisfaction',
      neutral: 'ss_ok_satisfaction',
      bad: 'ss_bad_satisfaction',
    },
    comment: `[[ticket.requester.first_name]] just rated this ticket "[[rating]]"

[[feedback_comment]]

[View feedback in Simplesat](https://app.simplesat.io/feedback)`,
  }

  state = {
    tags: {
      good: '',
      neutral: '',
      bad: '',
    },
    comment: '',
  }

  onChangeGoodTag = (event) => {
    this.setState(
      R.mergeDeepRight(this.state, {
        tags: {
          good: event.target.value,
        },
      })
    )
  }

  onChangeNeutralTag = (event) => {
    this.setState(
      R.mergeDeepRight(this.state, {
        tags: {
          neutral: event.target.value,
        },
      })
    )
  }

  onChangeBadTag = (event) => {
    this.setState(
      R.mergeDeepRight(this.state, {
        tags: {
          bad: event.target.value,
        },
      })
    )
  }

  onCommentChange = (event) => {
    this.setState({
      comment: event.target.value,
    })
  }

  componentDidMount() {
    this.setState({
      tags: this.props.tags,
      comment: this.props.comment,
    })
  }

  onClickUpdateSettings = (event) => {
    event.preventDefault()
    this.props.updateTicketTagsAndComment(this.state.tags, this.state.comment)
  }

  onClickDeactivate = (event) => {
    event.preventDefault()
    this.props.deactivateZendeskIntegration()
  }

  render() {
    return (
      <TagsAndCommentSettingsPresentation
        hideRemoveIntegration={this.props.hideRemoveIntegration}
        tags={this.state.tags}
        onChangeGoodTag={this.onChangeGoodTag}
        onChangeNeutralTag={this.onChangeNeutralTag}
        onChangeBadTag={this.onChangeBadTag}
        onClickUpdateSettings={this.onClickUpdateSettings}
        onClickDeactivate={this.onClickDeactivate}
      />
    )
  }
}

const mapState = ({ data }, { surveyId }) => ({
  tags: R.path(
    ['surveys', 'entity', surveyId, 'settings', 'updateTicketTagsAndComment', 'tags'],
    data
  ),
  comment: R.path(
    ['surveys', 'entity', surveyId, 'settings', 'updateTicketTagsAndComment', 'comment'],
    data
  ),
})

const mapDispatch = (dispatch, { surveyId }) => ({
  updateTicketTagsAndComment: (tags, comment) =>
    dispatch(updateTicketTagsAndComment(surveyId, tags, comment)),
  deactivateZendeskIntegration: () => dispatch(deactivateZendeskIntegration(surveyId)),
})

export default connect(mapState, mapDispatch)(TagsAndCommentSettings)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/Admin/Surveys/ZendeskIntegrationSettings/TagsAndCommentSettings/index.js